module.exports = __webpack_public_path__ + "static/media/item_5_30_comp.110cf8d1.png";